import React from 'react'
import { Box, Select as Base } from 'rebass'
import startCase from 'lodash.startcase'

import Text from './Text'
import Label from './Label'

const Select = ({hideLabel, placeholder, label, required, options, children, field, form: {touched, errors, isSubmitting}, ...others}) =>
  <Box mb={2}>
    {!hideLabel && <Label>{startCase(label || field.name)}{required && ' *'}</Label>}
    <Base mb={1} readOnly={isSubmitting} {...field} {...others}>
      {placeholder && <option value='' default disabled>{placeholder}</option>}
      {children && children}
      {options && options.map(o =>
        o.group
          ? <optgroup> </optgroup>
          : <option key={o.value} value={o.value}>{o.label}</option>
      )}
    </Base>
    {touched[field.name] && errors[field.name] && <Text error f={1} ml={2}>{errors[field.name]}</Text>}
  </Box>

export default Select


// WEBPACK FOOTER //
// ./src/components/Select.js